import CityPageTemplate from "../city-template/CityPageTemplate";
import { mcleanVaConfig } from "./data";

export default function McLeanVaPage() {
  return <CityPageTemplate config={mcleanVaConfig} />;
}